export default __webpack_public_path__ + "static/media/563.42aeff79.jpg";